import React from 'react';
import { InfoMessage } from '../components/InfoMessage/InfoMessage';

const documents = require('b_').with('documents');

export const ConsentSuccess = ({ name, onReset }) => (
    <div className={documents('revoke-section')}>
        Согласие на обработку персональных данных для {name} успешно отозвано.
        <div style={{ marginTop: 24 }}>
            <a href="#" onClick={(e) => { e.preventDefault(); onReset(); }}>
                Отозвать еще одно согласие
            </a>
        </div>
    </div>
);
